import axios from "axios";
import ApiQuery from "../components/utils/apiQuery/apiQuery";
let apiQuery = new ApiQuery();
let SERVIDOR_NODE = process.env.REACT_APP_API_URL;
let ADMINISTRADOR = process.env.REACT_APP_ADMIN_URL;
let COMPANY_NAME = (process.env.REACT_APP_COMPANY_NAME || '').trim();
let COOKIE_DOMAIN = (process.env.REACT_APP_COOKIE_DOMAIN || '').trim();


// const configuration = {
// 	method: "get",
// 	url: "http://localhost:8088/api/dolar",
// };
// let DOLAR_OFICIAL_VENTA;
// // make the API call
// axios(configuration)
// 	.then((result) => {
// 		DOLAR_OFICIAL_VENTA = result
// 		// console.log(DOLAR_OFICIAL_VENTA);

// 	})
// 	.catch((error) => {
// 		error = new Error();
// 	})

// function dolarQuery() {
// 	return 2000
// 	apiQuery.get(`/api/dolar`)
// 		.then((respuesta) => {
// 			return respuesta
// 		})
// }
// apiQuery.get(`/api/dolar`)
// 	.then((respuesta) => {
// 		console.log(`Valor del DOLAR: ${respuesta}`);
// 		//   setIsAdmin(respuesta)

// 	})

export const config = {
	// SERVER_LOCAL: `http://localhost:8088`,
	SERVER: SERVIDOR_NODE || `http://localhost:8088`,
	DOLAR: 0,
	ADMINISTRADOR: ADMINISTRADOR || `http://localhost:3001`,
	COMPANY_NAME,
	COOKIE_DOMAIN,
}

// Production can serve the catalog and administrator from sibling
// subdomains. Keep the domain configurable so local development remains
// host-only and does not attempt to set an invalid localhost cookie.
export function setAuthCookie(cookies, name, value) {
	const options = { path: "/" };
	if (COOKIE_DOMAIN) options.domain = COOKIE_DOMAIN;
	cookies.set(name, value, options);
	// Remove the old host-only cookie left by previous releases. The shared
	// cookie above remains available to both catalog and administrator.
	if (COOKIE_DOMAIN) cookies.remove(name, { path: "/" });
}

export function syncAuthCookie(cookies, name) {
	if (!COOKIE_DOMAIN) return;
	const value = cookies.get(name);
	if (!value) return;
	setAuthCookie(cookies, name, value);
}

export function removeAuthCookie(cookies, name) {
	cookies.remove(name, { path: "/" });
	if (COOKIE_DOMAIN) cookies.remove(name, { path: "/", domain: COOKIE_DOMAIN });
}

// export const config = async () => {
// 	// SERVER_LOCAL: `http://localhost:8088`,
// 	try {
// 		let result = await axios(configuration)
// 		DOLAR_OFICIAL_VENTA =[...result.data].filter((tipo)=> tipo.casa.nombre == "Dolar Oficial")[0].casa.venta
// 			console.log(DOLAR_OFICIAL_VENTA);

// 		return(
// 			{
// 				DOLAR: DOLAR_OFICIAL_VENTA ? parseFloat(DOLAR_OFICIAL_VENTA) : 232,
// 			}
// 		)
// 	} catch (error) {
// 		console.log(error);
// 	}
// }

// async function config() {
// 	const result = await axios(configuration)
// 	let DOLAR_OFICIAL_VENTA =[...result.data].filter((tipo)=> tipo.casa.nombre == "Dolar Oficial")[0].casa.venta
// 	return {
// 		DOLAR: DOLAR_OFICIAL_VENTA ? parseFloat(DOLAR_OFICIAL_VENTA) : 232,
// 	}
//     }

//     module.exports = config()
